<div class="page-container">

  <!-- Header -->
  <div class="header-section">
    <h1>{{ headerTitle }}</h1>
    <button class="btn-primary" (click)="addNew()">
      <span class="material-icons">add</span>
      Add New
    </button>
  </div>

  <!-- Filter Section -->
  <div class="filter-section">
    <div class="search-box">
      <span class="material-icons search-icon">search</span>
      <input pInputText [(ngModel)]="searchText" (input)="onSearchChange()" placeholder="Search..."
        class="search-input" />
      <button *ngIf="searchText" class="clear-search-btn" (click)="clearSearch()">
        <span class="material-icons">close</span>
      </button>
    </div>
    <div class="filter-info">
      <span class="result-count">{{ gridView.total }} Items found</span>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner styleClass="labtech-spinner" ariaLabel="Loading"></p-progressSpinner>
    <p>Loading...</p>
  </div>

  <!-- Cards Grid -->
  <div class="cards-grid" *ngIf="!loading">
    <div class="card master-data-card" *ngFor="let item of gridView.data; trackBy: trackByItem">

      <div class="card-header">
        <div class="card-icon">
          <span class="material-icons">checklist</span>
        </div>
        <div class="card-title-section">
          <h3 class="card-title">{{ item.titleDE || item.titleEN || 'No title' }}</h3>
        </div>
        <span class="na-chip" *ngIf="item.naAvailable">N/A</span>
        <div class="card-header-actions">
          <button type="button" class="card-icon-btn" (click)="toggleCardExpanded(item, $event)"
            [attr.aria-expanded]="isCardExpanded(item)"
            [title]="isCardExpanded(item) ? 'Collapse input fields' : 'Expand input fields'">
            <span class="material-icons">{{ isCardExpanded(item) ? 'close_fullscreen' : 'open_in_full' }}</span>
          </button>
          <button type="button" class="card-icon-btn" (click)="toggleActionMenu(item, $event)"
            [attr.aria-expanded]="isActionMenuOpen(item)" title="Card actions">
            <span class="material-icons">more_vert</span>
          </button>
          <div class="card-action-menu" *ngIf="isActionMenuOpen(item)" (click)="$event.stopPropagation()">
            <div class="menu-switch-row">
              <div>
                <span class="menu-label">N/A Available</span>
                <span class="menu-help">{{ item.naAvailable ? 'Enabled for this item' : 'Disabled for this item' }}</span>
              </div>
              <p-toggleSwitch [ngModel]="item.naAvailable" (ngModelChange)="onSwitchChange(item, $event)"></p-toggleSwitch>
            </div>
            <button type="button" class="menu-action menu-action-danger" (click)="openDeleteDialogFromMenu(item)">
              <span class="material-icons">delete</span>
              Delete
            </button>
          </div>
        </div>
      </div>

      <div class="card-body">

        <!-- Title DE -->
        <div class="info-row">
          <span class="material-icons info-icon">title</span>
          <div class="info-content">
            <span class="info-label">German</span>
            <ng-container *ngIf="isCardExpanded(item); else titleDeInput">
              <textarea class="expandable-input" [(ngModel)]="item.titleDE" (blur)="onFieldBlur(item)"
                placeholder="Title (DE)" rows="3"></textarea>
            </ng-container>
            <ng-template #titleDeInput>
              <input pInputText [(ngModel)]="item.titleDE" (blur)="onFieldBlur(item)" placeholder="Title (DE)" />
            </ng-template>
          </div>
        </div>

        <!-- Title EN -->
        <div class="info-row">
          <span class="material-icons info-icon">translate</span>
          <div class="info-content">
            <span class="info-label">English</span>
            <ng-container *ngIf="isCardExpanded(item); else titleEnInput">
              <textarea class="expandable-input" [(ngModel)]="item.titleEN" (blur)="onFieldBlur(item)"
                placeholder="Title (EN)" rows="3"></textarea>
            </ng-container>
            <ng-template #titleEnInput>
              <input pInputText [(ngModel)]="item.titleEN" (blur)="onFieldBlur(item)" placeholder="Title (EN)" />
            </ng-template>
          </div>
        </div>

      </div>

    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!loading && gridView.data.length === 0">
    <span class="material-icons empty-icon">search_off</span>
    <h3>No items found</h3>
    <p *ngIf="searchText">Try adjusting your search criteria</p>
    <p *ngIf="!searchText">Click "Add New" to create your first item</p>
  </div>

  <!-- Pagination -->
  <div class="pagination-section" *ngIf="!loading && gridView.total > 0">
    <p-paginator [totalRecords]="gridView.total" [rows]="gridState.take" [first]="gridState.skip" [rowsPerPageOptions]="[12, 24, 48]" (onPageChange)="pageChange($event)"></p-paginator>
    <span class="result-count pagination-range">{{ footerRangeLabel }}</span>
  </div>

  <!-- Delete Dialog -->
  <ng-container *ngIf="deleteDialog">
    <p-dialog [modal]="true" [visible]="true" header="Delete Item" (onHide)="toggleDeleteDialog()" [style]="{ width: '450px' }">
      <div class="dialog-content">
        <p>Are you sure you want to delete this item?</p>
        <p class="dialog-warning-text">The item will be soft deleted and hidden from the list.</p>
      </div>
      <ng-template pTemplate="footer">
        <button class="btn-secondary" (click)="toggleDeleteDialog()">Cancel</button>
        <button class="btn-primary" (click)="confirmDelete()">
          <span class="material-icons">delete</span>
          Delete
        </button>
      </ng-template>
    </p-dialog>
  </ng-container>

</div>
